import { useEffect, useRef } from "react";
import useVideoContext from "../useVideoContext/useVideoContext";
import { RoomEvent } from "livekit-client";

export const useDataTrack = (callback = () => {}) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const { room } = useVideoContext();

  useEffect(() => {
    const decoder = new TextDecoder();

    const onTrackMessage = (data) => {
      try {
        const strData = decoder.decode(data);
        callbackRef.current(JSON.parse(strData));
      } catch (e) {
        console.error("[useDataTrack] Failed to parse data track message:", e);
      }
    };

    console.debug("[useDataTrack] Listener attached", { roomName: room?.name });
    room.on(RoomEvent.DataReceived, onTrackMessage);

    return () => {
      console.debug("[useDataTrack] Listener detached", { roomName: room?.name });
      room.off(RoomEvent.DataReceived, onTrackMessage);
    };
  }, [room]);

  return callback;
};
